import { RolEnum } from "./enums/TipoRoles.enum";


export const RolesMap: Map<number, string> = new Map([
  [RolEnum.Administrador, "Administrador"],
  [RolEnum.Abogado, "Abogado"],
  [RolEnum.Paralegal, "Paralegal"],
  [RolEnum.MinisterioPublico, "Ministerio Público"],
]);

/**
 * Mapa que relaciona IdCalidad con IdTipoCalidad
 */
export const calidadToTipoCalidadRecord: Record<number, number> = {
  1: 2,
  2: 1,
  3: 1,
  4: 2,
  5: 2,
  6: 1,
  7: 2,
  8: 1,
  9: 2,
  10: 2,
  11: 2,
  12: 7,
  13: 2,
  14: 1,
  15: 2,
  16: 1,
  17: 9,
  18: 2,
  19: 1,
  20: 2,
  21: 1,
  22: 6,
  23: 1,
  24: 1,
  25: 2,
  26: 1,
  27: 1,
  28: 2,
  29: 1,
  30: 2,
  31: 6,
  32: 2,
  33: 1,
  34: 8,
  35: 2,
  37: 2,
  38: 6,
  39: 2,
  40: 2,
  41: 2,
  42: 2,
  43: 1,
  44: 1,
  45: 2,
  46: 1,
  48: 2,
  49: 7,
  50: 7,
  51: 7,
  52: 1,
  53: 7,
  54: 2,
  55: 2,
  56: 2,
  57: 7,
  58: 7,
  59: 1,
  60: 2,
  61: 2,
  62: 2,
  63: 2,
  64: 2,
  65: 2,
  66: 1,
  67: 1,
  68: 7,
  69: 7,
  70: 7,
  71: 7,
  72: 7,
  73: 7,
  74: 6,
  76: 7,
  77: 7,
  78: 1,
  79: 8,
  81: 7,
  82: 6,
  83: 6,
  85: 1,
  86: 1,
  87: 2,
  // 89: null,
  // 90: null,
  // 91: null,
  92: 1,
  93: 6,
  94: 6,
  95: 7,
  96: 7,
  97: 2,
  98: 7,
};

/**
 * Método que retorna el IdTipoCalidad dado el IdCalidad
 * @param idCalidad - El ID de la calidad
 * @returns El ID del tipo de calidad o null si no existe
 */
export function getIdTipoCalidad(idCalidad: number): number {
  return calidadToTipoCalidadRecord[idCalidad] ?? 0;
}

/**
 * Mapa que relaciona IdCalidad con el nombre de la Calidad
 */
export const calidadNamesRecord: Record<number, string> = {
  1: "Demandante",
  2: "Demandado",
  3: "Imputado",
  4: "Agraviado",
  5: "Accionante",
  6: "Accionado",
  7: "Impetrante",
  8: "Impetrado",
  9: "Solicitante",
  10: "Interviniente forzoso",
  11: "Interviniente voluntario",
  12: "Testigo",
  13: "Recurrente",
  14: "Recurrido",
  15: "Persiguiente",
  16: "Perseguido",
  17: "Depositante",
  18: "Recusante",
  19: "Recusado",
  20: "Declarado",
  21: "Interdicto",
  22: "Representante Administración Pública",
  23: "Imputado y tercero civilmente demandado",
  24: "Imputado y civilmente demandado",
  25: "Querellante y actor civil",
  26: "Tercero civilmente demandado",
  27: "Embargado",
  28: "Impugnante",
  29: "Impugnado",
  30: "Embargante",
  31: "Ministerio Público",
  32: "Actor Civil",
  33: "Condenado",
  34: "Defensor",
  35: "Querellante",
  37: "Víctima",
  38: "Autoridad Penitenciaria",
  39: "Titular",
  40: "Acusador Privado",
  41: "Acusador Privado y Actor Civil",
  42: "Objetante",
  43: "Objetado",
  44: "Investigado/a",
  45: "Imputado Recurrente",
  46: "Imputado Recurrido",
  48: "Querellante",
  49: "Licitador",
  50: "Perito",
  51: "Interprete",
  52: "Querellado",
  53: "Garante",
  54: "Víctima y Querellante",
  55: "Víctima, Querellante y Actor Civil",
  56: "Víctima y Testigo",
  57: "Testigo a Cargo",
  58: "Testigo a Descargo",
  59: "Penado",
  60: "Denunciante",
  61: "Victima, Querellante, Actor Civil y Testigo",
  62: "Querellante Recurrente",
  63: "Querellante y Actor Civil Recurrente",
  64: "Oponente",
  65: "Reclamante",
  66: "Compañía Aseguradora",
  67: "Beneficiario de la Póliza",
  68: "Militar Actuante",
  69: "Policía Actuante",
  70: "Militar Actuante Pensionado",
  71: "Policía Actuante Pensionado",
  72: "Militar Actuante Desvinculado",
  73: "Policía Actuante Desvinculado",
  74: "Abogado del Estado",
  76: "Comprador",
  77: "Vendedor",
  78: "Denunciado",
  79: "Representante del Menor Imputado",
  81: "Representante de la Víctima",
  82: "Procurador(a) Fiscal Especializado(a) de Niños, Niñas y Adolescentes",
  83: "Procurador(a) Fiscal Especializado(a) de Niños, Niñas y Adolescentes",
  85: "Empleador",
  86: "Sancionado",
  87: "Deudor",
  92: "Imputado y Víctima",
  93: "Procurador(a) Fiscal",
  94: "Fiscalizador",
  95: "Testigo a Cargo y Descargo",
  96: "Testigo",
  97: "Víctima y Recurrente",
  98: "Fiador",
};

/**
 * Mapa que relaciona IdTipoCalidad con el nombre del TipoCalidad
 */
export const tipoCalidadNamesMap: Record<number, string> = {
  1: "Demandado",
  2: "Demandante",
  6: "Componente Tribunal",
  7: "Participante",
  8: "Representante",
  9: "Depositante",
};

/**
 * Método que retorna el nombre de la Calidad dado el IdCalidad
 * @param idCalidad - El ID de la calidad
 * @returns El nombre de la calidad o null si no existe
 */
export function getNombreCalidad(idCalidad: number): string | null {
  return calidadNamesRecord[idCalidad] ?? null;
}

/**
 * Método que retorna el nombre del TipoCalidad dado el IdCalidad
 * @param idCalidad - El ID de la calidad
 * @returns El nombre del tipo de calidad o null si no existe
 */
export function getNombreTipoCalidadPorIdCalidad(idCalidad: number): string | null {
  const idTipoCalidad = getIdTipoCalidad(idCalidad);
  if (idTipoCalidad === 0) return null;
  return tipoCalidadNamesMap[idTipoCalidad] ?? null;
}
